import { UseFormReturn } from 'react-hook-form'

import { useEffect } from '@factorialco/deprecated-design-system'
import { Select } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import {
  GENERATION_METHODS,
  SchemaType,
} from 'modules/shift_management/lib/forms/GenerateCoverageForm'

interface Props {
  generationMethod: keyof typeof GENERATION_METHODS
  form: UseFormReturn<SchemaType>
  disabled: boolean
  shiftsAlert: boolean
  coverageAlert: boolean
}

const GenerationMethod = observer(
  ({ generationMethod, form, disabled, shiftsAlert, coverageAlert }: Props) => {
    const handleChange = (value: keyof typeof GENERATION_METHODS) => {
      form.setValue('generationMethod', value)
    }

    useEffect(() => {
      if (!shiftsAlert && !coverageAlert) return
      if (shiftsAlert) {
        handleChange(GENERATION_METHODS.previous_coverage)
        return
      }
      handleChange(GENERATION_METHODS.from_shifts)
    }, [shiftsAlert, coverageAlert])

    return (
      <Select
        key={generationMethod}
        options={[
          {
            label: i18n.t(
              'shift_management.coverage_section.generate_coverage_modal.generate_method_options.from_shifts.title'
            ),
            value: GENERATION_METHODS.from_shifts,
            description: i18n.t(
              'shift_management.coverage_section.generate_coverage_modal.generate_method_options.from_shifts.description'
            ),
            disabled: shiftsAlert,
          },
          {
            label: i18n.t(
              'shift_management.coverage_section.generate_coverage_modal.generate_method_options.previous_coverage.title'
            ),
            value: GENERATION_METHODS.previous_coverage,
            description: i18n.t(
              'shift_management.coverage_section.generate_coverage_modal.generate_method_options.previous_coverage.description'
            ),
            disabled: coverageAlert,
          },
        ]}
        value={generationMethod}
        onChange={(value: keyof typeof GENERATION_METHODS) => {
          handleChange(value)
        }}
        size="md"
        loading={false}
        placeholder={i18n.t(
          'shift_management.coverage_section.generate_coverage_modal.generation_method_field'
        )}
        label={i18n.t(
          'shift_management.coverage_section.generate_coverage_modal.generation_method_field'
        )}
        hideLabel
        disabled={disabled}
      />
    )
  }
)

export { GenerationMethod }
